// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__4jVDH","modal":"Modal_modal__N1+WB"};